import Layout from '@/components/feature/Layout';
import SEO from '@/components/feature/SEO';
import HeroSection from './components/HeroSection';
import RiskCards from './components/RiskCards';
import CategoryCards from './components/CategoryCards';
import FeaturedArticles from './components/FeaturedArticles';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import { siteInfo } from '@/mocks/site';
import { getOrganizationSchema, getWebSiteSchema, getWebPageSchema, getFAQSchema } from '@/utils/structuredData';
import { faqItems } from '@/mocks/faq';

export default function Home() {
  const homeJsonLd = [
    getOrganizationSchema(),
    getWebSiteSchema(),
    getWebPageSchema(siteInfo.fullName, siteInfo.description, siteInfo.url),
    getFAQSchema(faqItems),
  ];

  return (
    <Layout>
      <SEO
        title={siteInfo.fullName}
        description={siteInfo.description}
        keywords="茄子视频污,茄子视频风险,不良视频危害,正规短视频平台,健康娱乐内容,视频平台合规,青少年网络安全"
        canonicalUrl={siteInfo.url}
        jsonLd={homeJsonLd}
      />
      <HeroSection />
      <RiskCards />
      <CategoryCards />
      <FeaturedArticles />
      <FAQSection />
      <CTASection />
    </Layout>
  );
}